import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyOrderStatusBar, { BuyOrderStatusBarNew, CreateStatusBarProps } from '../../../BuyOrderStatusBar'
import BuyOrderWaitingResponseStepButtons, { BuyOrderWaitingResponseStepButtonsNew } from '../BuyOrderWaitingResponseStepButtons'

type BuyOrderWaitingResponseStepHeaderProps = & CreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyOrderWaitingResponseStepHeaderDecider: React.FC<BuyOrderWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyOrderWaitingResponseStepHeaderDefault} NewComponent={BuyOrderWaitingResponseStepHeaderNew} {...rest} />
    )
}

const BuyOrderWaitingResponseStepHeaderDefault: React.FC<BuyOrderWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyOrderStatusBar {...rest} />
            <BuyOrderWaitingResponseStepButtons {...rest} />
        </div>
    )
}

const BuyOrderWaitingResponseStepHeaderNew: React.FC<BuyOrderWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyOrderStatusBarNew {...rest} />
            <BuyOrderWaitingResponseStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyOrderWaitingResponseStepHeaderDecider